import React, { Component } from "react";
import { node, func, bool, shape, string, number } from "prop-types";

import MainContainer from "pages/_components/MainContainer";
import ProductFilters from "pages/_components/ProductFilters";
import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import CustomHeadInfo from "pages/accounts/_components/CustomHeadInfo";
import Drawer from "pages/_components/Drawer/Drawer";

import * as i18n from "util/i18n";
import YearMonthFilter from "pages/accounts/_components/YearMonthFilter";
import FilterTags from "./FilterTags";
import CustomText from "./CustomText/CustomText";

class ProductBody extends Component {
    static propTypes = {
        children: node.isRequired,
        fetching: func.isRequired,
        isDesktop: bool.isRequired,
        filters: shape().isRequired,
        filtersClass: string,
        moreFilters: node.isRequired,
        dispatch: func.isRequired,
        productId: string.isRequired,
        persistentTabs: bool,
        setCurrentTab: func,
        account: shape().isRequired,
        selectedAccountBalances: shape({
            totalBalance: number,
            availableBalance: number,
            proyectedOverdraftBalance: number,
        }).isRequired,
        specialFilter: bool,
    };

    static defaultProps = {
        filtersClass: "",
        persistentTabs: false,
        setCurrentTab: () => {},
        specialFilter: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            openSidebar: false,
        };
    }

    render() {
        const {
            account,
            children,
            fetching,
            filters,
            isDesktop,
            moreFilters,
            dispatch,
            productId,
            persistentTabs,
            selectedAccountBalances,
            setCurrentTab,
            specialFilter,
            filtersClass,
            ...rest
        } = this.props;

        const childrenWIthFIlters = () => (
            <div className="container">
                {filters && (
                    <ProductFilters className={filtersClass} {...rest} moreFilters={moreFilters}>
                        {filters}
                    </ProductFilters>
                )}
                {children[0]}
            </div>
        );
        const openSideBarFilters = () => {
            this.setState({ openSidebar: true });
        };

        const handleSideBarFilters = () => {
            this.setState((prevState) => ({ openSidebar: !prevState.openSidebar }));
        };

        const accountSummary = () => (
            <div className="container">
                {specialFilter && (
                    <>
                        <FilterTags openSideBarFilters={openSideBarFilters} />
                        <Drawer openSidebar={this.state.openSidebar} toggleSidebar={handleSideBarFilters}>
                            <div className="container full-width">
                                <h2 className="title-content">
                                    <CustomText text="debin.filter" textType="I18N" />
                                </h2>
                                <div className="row height-100">
                                    <YearMonthFilter
                                        dispatch={dispatch}
                                        productId={productId}
                                        handleCloseSearch={handleSideBarFilters}
                                        specialFilter
                                    />
                                </div>
                            </div>
                        </Drawer>
                    </>
                )}
                {!specialFilter && <YearMonthFilter dispatch={dispatch} productId={productId} />}

                {children[1]}
            </div>
        );

        const tabs = [
            {
                text: i18n.get(`accounts.movements`),
                content: childrenWIthFIlters(),
            },
            {
                text: i18n.get(`accounts.summary`),
                content: accountSummary(),
            },
        ];
        return (
            <MainContainer showLoader={fetching}>
                {(isDesktop && (
                    <>
                        {account && (
                            <CustomHeadInfo
                                balance={selectedAccountBalances.totalBalance || "0"}
                                countableBalance={selectedAccountBalances.availableBalance || "0"}
                                currency={account.currency}
                                overdraftLine={selectedAccountBalances.proyectedOverdraftBalance || "0"}
                                pendingBalance={selectedAccountBalances.pendingBalance || "0"}
                                {...this.props}
                            />
                        )}
                        <CustomTabs tabsData={tabs} isPersistent={persistentTabs} setCurrentTab={setCurrentTab} />
                    </>
                )) || (
                    <>
                        {account && (
                            <CustomHeadInfo
                                balance={selectedAccountBalances.totalBalance || "0"}
                                countableBalance={selectedAccountBalances.availableBalance || "0"}
                                currency={account.currency}
                                overdraftLine={selectedAccountBalances.proyectedOverdraftBalance || "0"}
                                {...this.props}
                            />
                        )}
                        <CustomTabs tabsData={tabs} isPersistent={persistentTabs} setCurrentTab={setCurrentTab} />
                    </>
                )}
            </MainContainer>
        );
    }
}

export default ProductBody;
